import {
  GET_AUDIT_RECORDS_REQUEST,
  GET_AUDIT_RECORDS_SUCCESS,
  GET_AUDIT_RECORDS_ERROR,
  GET_AUDIT_ITEMS_REQUEST,
  GET_AUDIT_ITEMS_SUCCESS,
  GET_AUDIT_ITEMS_ERROR,
  GET_ASSET_AUDITS_REQUEST,
  GET_ASSET_AUDITS_SUCCESS,
  GET_ASSET_AUDITS_ERROR,
  CREATE_AUDIT_REQUEST,
  CREATE_AUDIT_SUCCESS,
  CREATE_AUDIT_ERROR,
  DELETE_AUDIT_REQUEST,
  DELETE_AUDIT_SUCCESS,
  DELETE_AUDIT_ERROR,
  SCAN_AUDIT_ITEM_SUCCESS,
  COMPLETE_AUDIT_REQUEST,
  COMPLETE_AUDIT_SUCCESS,
  COMPLETE_AUDIT_ERROR,
  RECONCILE_AUDIT_REQUEST,
  RECONCILE_AUDIT_SUCCESS,
  RECONCILE_AUDIT_ERROR,
} from './auditActionTypes';

const initialState = {
  isLoading: false,
  isSaving: false,
  isSuccess: false,
  message: '',
  // The audit list.
  auditRecords: [],
  count: 0,
  // One audit's checklist, and the audit it belongs to.
  auditRecord: {},
  auditItems: [],
  itemCount: 0,
  // Audits covering one asset, for the asset detail page.
  assetAudits: [],
  assetAuditCount: 0,
};

export default function auditReducer(state = initialState, action) {
  const { type, payload, isLoading, message } = action;

  switch (type) {
    case GET_AUDIT_RECORDS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_RECORDS_SUCCESS:
      // `count` is on the envelope, not on the row array. The old reducer read
      // `payload.data.count`, which is undefined, so the pager never worked.
      return { ...state, isLoading, auditRecords: payload.data, count: payload.count };
    case GET_AUDIT_RECORDS_ERROR:
      return { ...state, isLoading, message };

    case GET_AUDIT_ITEMS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_ITEMS_SUCCESS:
      // The items response carries the parent audit, so the progress header and
      // the checklist stay in step without a second request.
      return {
        ...state,
        isLoading,
        auditItems: payload.data,
        auditRecord: payload.audit_record ?? state.auditRecord,
        itemCount: payload.count,
      };
    case GET_AUDIT_ITEMS_ERROR:
      return { ...state, isLoading, message };

    case GET_ASSET_AUDITS_REQUEST:
      return { ...state, isLoading };
    case GET_ASSET_AUDITS_SUCCESS:
      return { ...state, isLoading, assetAudits: payload.data, assetAuditCount: payload.count };
    case GET_ASSET_AUDITS_ERROR:
      return { ...state, isLoading, message };

    case SCAN_AUDIT_ITEM_SUCCESS:
      // Patch the scanned line in place. Refetching the page after every scan
      // made the scanner lag behind the person holding it.
      return {
        ...state,
        auditItems: state.auditItems.map((item) => (item.id === payload.data?.id ? payload.data : item)),
      };

    case CREATE_AUDIT_REQUEST:
    case DELETE_AUDIT_REQUEST:
    case COMPLETE_AUDIT_REQUEST:
    case RECONCILE_AUDIT_REQUEST:
      return { ...state, isSaving: true, isSuccess: false };
    case CREATE_AUDIT_SUCCESS:
    case DELETE_AUDIT_SUCCESS:
    case COMPLETE_AUDIT_SUCCESS:
    case RECONCILE_AUDIT_SUCCESS:
      return { ...state, isSaving: false, isSuccess: true, message };
    case CREATE_AUDIT_ERROR:
    case DELETE_AUDIT_ERROR:
    case COMPLETE_AUDIT_ERROR:
    case RECONCILE_AUDIT_ERROR:
      return { ...state, isSaving: false, isSuccess: false, message };

    default:
      return state;
  }
}
